import { defaultObj } from './state'

export default {
  updateFieldTracking (state, data) {
    state.firstName = data.firstName || state.firstName
    state.middleName = data.middleName || state.middleName
    state.lastName = data.lastName || state.lastName
    state.cellPhoneNumber = data.cellPhoneNumber || state.cellPhoneNumber
    state.email = data.email || state.email
    state.dateOfBirth = data.dateOfBirth || state.dateOfBirth
    state.address = data.address || state.address
    state.mailingAddress = data.mailingAddress || state.mailingAddress
    state.zip = data.zip || state.zip
    state.mailingZip = data.mailingZip || state.mailingZip
    state.idNumber = data.idNumber || state.idNumber
    state.idExpiration = data.idExpiration || state.idExpiration
    state.tin = data.tin || state.tin
    state.incomeName = data.incomeName || state.incomeName
    state.routingNum = data.routingNum || state.routingNum
    state.accountNum = data.accountNum || state.accountNum
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
